module.exports = __webpack_public_path__ + "static/person-2-7593a6842658488df13a6b790a0765e2.jpeg";